import React, { ReactElement } from 'react';
import { Grid } from '@material-ui/core';
import Row from './components/row';
import useStyles from './styles';

interface IElementsProps {
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  element: ReactElement;
  id: string;
  rowStyle?: any;
}

interface IProps {
  elements: IElementsProps[];
  justify?: 'center' | 'flex-start';
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | undefined;
}

export default function GridLayout(props: IProps): ReactElement {
  // const classes = useStyles();

  return (
    <Grid
      container
      justify={props.justify ?? 'center'}
      alignItems="flex-start"
      spacing={props.spacing ?? 1}
    >
      {props.elements.map((_props) => (
        <Row
          key={_props.id}
          style={_props.rowStyle || {}}
          widthInLargeScreen={_props.size}
        >
          {_props.element}
        </Row>
      ))}
    </Grid>
  );
}
